define('validation--counter-choices',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var answers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var props = arguments[1];


        if (!Array.isArray(answers)) {
            return false;
        }

        var i = answers.filter(function (o) {
            return document.querySelector('[id="' + o.id + '"]:checked');
        }).length,
            res = answers.length && i > 0 ? true : false;

        if (!res || !props) {
            return res;
        }

        var msg = props.alert ? props.alert.replace(/(<([^>]+)>)/ig, '').trim() : '';

        if (msg) {
            var min = props.min && parseInt(props.min) ? parseInt(props.min) : 0,
                max = props.max && parseInt(props.max) ? parseInt(props.max) : 0;

            if (min && min > i || max && max < i) {
                return false;
            }
        }

        return res;
    };
});
